import { ComponentType, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { CustomTabs } from '../../shared/uiComponents';
import { Container } from '../../components/StyledComponents';
import { AdminTypes } from '../../components/Menu';

import MBHReport from './BillingReports/MBHReport';
import NonCredentialedReport from './BillingReports/NonCredentialedReport';
import NonBillableReport from './BillingReports/NonBillable';
import GraphReports from './GraphReports';
import DownloadSoapNotes from './SoapNotes';
import UtilizationReport from './UtilizationReport';
import PendingDSU from './PendingDSU';
import ExpiredSessions from './ExpiredSessions';
import AssessmentReport from './AssessmentReport';
import LimitedPermit from './LimitedPermit';
import BackdatedSessions from './BackdatedSessionsReport';

import { DispatchProperties, useSelector } from '../../redux/store';
import { clearFilterData } from '../../redux/State/clientSlice/billingSlice';
import AuthorizationReport from './AuthorizationReport';
import { Chart } from '../../shared/Assets/menuIcons';
import { PageHeader } from '../../components/PageHeader';

type ReportConfig = Array<{ Component: ComponentType; path: string }>;

const ReportComponentsByRole: Record<number, ReportConfig> = {
	[AdminTypes.admin]: [
		{ path: 'MBH', Component: MBHReport },
		{ path: 'Not Credentialed', Component: NonCredentialedReport },
		{ path: 'Not Billable', Component: NonBillableReport },
		{ path: 'Graph', Component: GraphReports },
		{ path: 'SOAP Notes', Component: DownloadSoapNotes },
		{ path: 'Utilization', Component: UtilizationReport },
		{ path: 'Pending DSU', Component: PendingDSU },
		{ path: 'Expired Sessions', Component: ExpiredSessions },
		{ path: 'Assessment', Component: AssessmentReport },
		{ path: 'Limited Permit', Component: LimitedPermit },
		{ path: 'Backdated Sessions', Component: BackdatedSessions },
		{ path: 'Authorization', Component: AuthorizationReport },
	],
	[AdminTypes.bcba]: [
		{ path: 'Graph', Component: GraphReports },
		{ path: 'Assessment', Component: AssessmentReport },
	],
	[AdminTypes.cs]: [
		{ path: 'Graph', Component: GraphReports },
		{ path: 'Assessment', Component: AssessmentReport },
		{ path: 'Utilization', Component: UtilizationReport },
		{ path: 'Authorization', Component: AuthorizationReport },
	],
};

const Reports = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const role = useSelector((state) => state.account.role);

	const { headers, panels } = useMemo(() => {
		const roleId = role?.section.id;
		const config = (roleId !== undefined && ReportComponentsByRole[roleId]) || [];

		return {
			headers: config.map((x) => x.path),
			panels: config.map((x) => x.Component),
		};
	}, [role?.section.id]);

	const clearFilters = () => dispatch(clearFilterData());

	return (
		<Container>
			<PageHeader icon={<Chart />} title="Reports" isInContainer customStyles={{ marginBottom: '24px' }} />
			<CustomTabs headers={headers} panels={panels} onHeaderClick={clearFilters} className="marginBottom16" />
		</Container>
	);
};

export default Reports;
